import React, { forwardRef } from "react";
import ReactSelect from "react-select";

// react-select's built-in texts ("Select...", "No options", "Loading...")
// are English. Every dropdown imports this wrapper instead; a screen can
// still pass its own noOptionsMessage or placeholder.
export const selectTexts = (emptyText = "موردی برای انتخاب وجود ندارد.") => ({
  noOptionsMessage: ({ inputValue }) =>
    inputValue ? `موردی با «${inputValue}» یافت نشد.` : emptyText,
  loadingMessage: () => "در حال بارگذاری…",
});

const DEFAULT_TEXTS = selectTexts();

const Select = forwardRef(
  ({ placeholder, noOptionsMessage, loadingMessage, ...props }, ref) => (
    <ReactSelect
      ref={ref}
      {...props}
      placeholder={placeholder ?? "انتخاب کنید…"}
      noOptionsMessage={noOptionsMessage ?? DEFAULT_TEXTS.noOptionsMessage}
      loadingMessage={loadingMessage ?? DEFAULT_TEXTS.loadingMessage}
    />
  ),
);

Select.displayName = "Select";

export default Select;
